import {useRef, useState} from 'react';
import dynamic from 'next/dynamic';
import type { ICalendar } from '@components/Buttons/Calendar/Calendar';
import DropDown from '@components/Buttons/DropDown';
import useDetectOutsideClick from '@hooks/useDetectOutsideClick';
import { useI18n } from '@i18n/useI18n';
import {Moment} from 'moment';
import styled from '@emotion/styled';
import Tooltip from '@components/Tooltips/Tooltip';

// Calendar (and the react-datepicker it wraps) is only ever shown once the user clicks to open
// this dropdown (see `{open && <Calendar .../>}` below) - a plain import still bundled it eagerly
// into every page that renders a DatePick, loading it on demand instead.
const Calendar = dynamic<ICalendar>(() => import('@components/Buttons/Calendar'), { ssr: false });

const StyledDropdown = styled(DropDown)<{order?:boolean, isActive?:boolean}>`
  z-index: ${props => props.order?"5": "2"};

  > div{
    transition: all 0.2s ease-in-out;
    background: ${props => props.isActive?props.theme.colors.buttonHoverColor:null};
    
    input{
      transition: all 0.2s ease-in-out;
      color:${props => props.isActive?"#fff":"#000"};
      border-color:${props => props.isActive?props.theme.colors.buttonHoverColor:null};
    }
  }


  .react-datepicker {
    z-index: 15;
    position: absolute;
  }
`;


interface IProps{
  max?:Moment,
  min?:Moment,
  date:Moment,
  type?:number,
  tooltip?: string,
  handleOnChange: (e:any, type:number) => void;
  isActive?:boolean,
}

export const DatePick = (props:IProps) => {
  const [open, setopen] = useState(false);
  const i18n = useI18n();
  const wrapperRef = useRef(null);
  const handleOutsideClick = () => {
    setopen(false);
  };

  useDetectOutsideClick(wrapperRef, handleOutsideClick);

  const handleClick = () => {
    setopen(false);
  };

  const handleClickTemp = (e) => {
    e.stopPropagation()
    setopen(!open);
  };

  const temp = (e) => {
    props.handleOnChange(e, props.type)
    setopen(!open);
  }

  return (
    <>
      <StyledDropdown order={props.type === 1} /*title={'date'}*/ open={open} ref={wrapperRef} isActive={props.isActive}>
      <Tooltip placement='top-center' content={i18n.t(props.tooltip)}>
        <input type="button" onClick={handleClickTemp} value={props.date.format('DD-MM-yyyy')} />
      </Tooltip>
        {open && (
          <Calendar 
          open={open} 
          close={handleClick} 
          selected={props.date.toDate()}
          minDate={props.min?.toDate()} 
          maxDate={props.max?.toDate()} 
          onChange={temp}
          />
        )}
      </StyledDropdown>
    </>
  );
};

export default DatePick;
